class Header {
	constructor() {
		this.header = document.querySelector(".header-main");

		if (!this.header) {
			return;
		}

		this.lev1Parents = document.querySelectorAll(".lev1 > li.menu-item-has-children:not(.no-mega-menu)");
		this.toggleHeaderOnScroll();
		this.toggleMobileNavOnClick();
		if (mobileCheck.isMobile) {
			this.toggleHeaderSubnavOnClick();
		} else {
			this.minimalUserInteraction();
		}
		resizeCallbacks.push(this);
	}

	toggleMobileNavOnClick() {
		const openTrigger = document.querySelector(".nav-main-open");
		const closeTrigger = document.querySelector(".nav-main-close");

		openTrigger.addEventListener("click", () => {
			this.openNav();
		});

		closeTrigger.addEventListener("click", () => {
			this.closeNav();
		});

		this.lev1Parents.forEach(link => {
			const subnav = link.querySelector(".lev2");
			link.addEventListener("click", () => {
				if (window.innerWidth <= 991) {

					if (!link.classList.contains("active")) {
						link.classList.add("active");
						subnav.style.display = "block";
						gsap.to(subnav, {
							opacity: 1,
							duration: 0.2,
							onComplete: () => {
							}
						});
					} else {
						link.classList.remove("active");
						gsap.to(subnav, {
							opacity: 0,
							duration: 0.2,
							onComplete: () => {
								subnav.style.display = "none";
							}
						});
					}

				}
			});
		});
	}

	minimalUserInteraction() {
		let totalDistance = 0;
		let oldCursorX, oldCursorY;
		let thresholdCrossed = false;

		let thresholdListener = (e) => {
			if (thresholdCrossed) {
				document.removeEventListener("mousemove", thresholdListener);
				return;
			}

			const cursorMoveThreshold = 100;

			if (oldCursorX && oldCursorY) {
				totalDistance += Math.sqrt(Math.pow(oldCursorY - e.clientY, 2) + Math.pow(oldCursorX - e.clientX, 2));
			}

			if (totalDistance > cursorMoveThreshold) {
				thresholdCrossed = true;
				this.toggleHeaderSubnavOnHover();
			}

			oldCursorX = e.clientX;
			oldCursorY = e.clientY;
		};

		document.addEventListener("mousemove", thresholdListener);
	}

	toggleHeaderSubnavOnClick() {
		this.header.classList.add("mega-menu-active");
		const closeBtns = document.querySelectorAll(".lev2 .subnav-close");

		this.lev1Parents.forEach(link => {
			link.addEventListener("click", (e) => {
				if (window.innerWidth > 991) {
					this.lev1Parents.forEach(link2 => {
						link2.classList.remove("active");
					});
					this.header.classList.add("mega-menu-opened");
					link.classList.add("active");
					smoother.paused(true);
				}

			});
		});

		closeBtns.forEach(btn => {
			btn.addEventListener("click", () => {
				setTimeout(() => {
					this.lev1Parents.forEach(link => {
						link.classList.remove("active");
						this.header.classList.remove("mega-menu-opened");
						smoother.paused(false);
					});
				}, 0);
			});
		});
	}

	toggleHeaderSubnavOnHover() {
		this.header.classList.add("mega-menu-active");

		this.lev1Parents.forEach(link => {
			link.addEventListener("mousemove", () => {
				if (window.innerWidth > 991) {
					this.header.classList.add("mega-menu-opened");
					link.classList.add("active");
					smoother.paused(true);
				}
			});

			link.addEventListener("mouseleave", () => {
				if (window.innerWidth > 991) {
					this.header.classList.remove("mega-menu-opened");
					link.classList.remove("active");
					smoother.paused(false);
				}
			});
		});
	}

	toggleHeaderOnScroll() {
		const showAnim = gsap.from(this.header, {
			yPercent: -100,
			paused: true,
			duration: 0.5,
			ease: 'expo.out'
		}).progress(1);


		// window.addEventListener("wheel", (e) => {
		// 	if (!this.navIsOpened) {
		// 		if (e.deltaY > 30 && !this.header.classList.contains("mega-menu-opened")) {
		// 			showAnim.reverse();
		// 			this.header.classList.remove("mega-menu-active");
		//
		// 		} else if (e.deltaY < -10) {
		// 			showAnim.play();
		// 			this.header.classList.add("mega-menu-active");
		// 		}
		// 	}
		// });


		Observer.create({
			type: "scroll",
			tolerance: 30,
			dragMinimum: 30,
			onStop: () => {
				if (smoother.scrollTop() < this.header.offsetHeight) {
					showAnim.play();
					this.header.classList.add("mega-menu-active");
				}
			},
			onStopDelay: 0.5,
			onUp: () => {
				if (this.header.classList.contains("mega-menu-opened") ||
					document.body.classList.contains("nav-is-opened")) {
					return;
				}
				showAnim.play();
				this.header.classList.add("mega-menu-active");
			},
			onDown: () => {
				if (this.header.classList.contains("mega-menu-opened") ||
					document.body.classList.contains("nav-is-opened")) {
					return;
				}
				showAnim.reverse();
				this.header.classList.remove("mega-menu-active");
			},

		});
	}

	openNav() {
		document.body.classList.add("nav-is-opened");
		smoother.paused(true);
	}

	closeNav() {
		document.body.classList.remove("nav-is-opened");
		smoother.paused(false);

		if (window.innerWidth > 991) {
			const activeSubnavs = this.header.querySelectorAll(".nav-main li.active");
			activeSubnavs.forEach(subnav => {
				subnav.classList.remove('active');
				subnav.querySelector(".lev2").removeAttribute("style");
			});
		}
	}

	resize() {
		this.closeNav();
	}
}